import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import ProcessSuccess from "../../components/ProcessSuccess/ProcessSuccess";
import TermsAndConditionModal from "../../components/TermsAndConditionModal/TermsAndConditionModal";
import { ArrowIcon } from "../../front-end-global-components/assets/assets";
import Button from "../../front-end-global-components/components/Button/Button";
// import CheckBox from "../../front-end-global-components/components/CheckBox/CheckBox";
import Header from "../../front-end-global-components/components/Header/Header";
import InputBox from "../../front-end-global-components/components/InputBox/InputBox";
import Modal from "../../front-end-global-components/components/Modal/Modal";
import NativeSelect from "../../front-end-global-components/components/NativeSelect/NativeSelect";
import RoundedProfilePicture from "../../front-end-global-components/components/RoundedProfilePicture/RoundedProfilePicture";
import TextArea from "../../front-end-global-components/components/TextArea/TextArea";
import {
  checkHealthIdExists,
  clearHealthIdExistsStatus
} from "../../redux/abdm/actions";
import { switchLoginWithCustomToken } from "../../redux/authentication/actions";
import { createHealthId, setTransactionId } from "../../redux/patients/actions";
import { suggestABHAAddress } from "../../services/api";
import {
  deFormatABHANumber,
  getDateForYearAndMonth,
  getMonthName,
  getMonthNumber,
  getValidGender,
  months,
  returnYearArrayForSelectBox,
  stateCodeWithDistricts,
  stateOptionsWithCode
} from "../../utils/constants";
import { healthIdSchema } from "../../utils/models";
import { Regex } from "../../utils/regex";
import { isValidArray, validation } from "../../utils/validators";

function ABDMCreate(props) {
  const [authMode, setAuthMode] = useState(null);
  const [mobile, setMobile] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const authData = new URLSearchParams(window.location.search)?.get(
      "authMode"
    );
    const mobileData = new URLSearchParams(window.location.search)?.get(
      "mobile"
    );
    if (mobileData) {
      setMobile(`+${mobileData.trim()}`);
    }

    if (authData) {
      setAuthMode(authData);
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (!props.patients?.transaction?.id) {
      navigate("/abdm/login", { replace: true });
    }
    // eslint-disable-next-line
  }, [props.patients?.transaction?.id]);

  return (
    <>
      <Header
        title="Create ABHA Address"
        backButtonOnClick={() => {
          if (location.pathname.includes("abhaDetails")) {
            navigate("/abdm/create");
          } else {
            navigate("/abdm/login");
          }
        }}
        hideSupport={true}
        incident={props.app.featureFlags?.incident?.patients}
        incidentOnClick={() => {
          navigate("/incidents");
        }}
      />
      <section className="remaining-body-height max-width-588px margin-horizontal-auto overflow-y-auto inherit-parent-width ">
        <CreateHealthId
          mobileNumber={mobile}
          auth={props.auth}
          patients={props.patients}
          loading={props.patients.loading || props.abdm.loading}
          authMode={authMode}
          isHealthIdExists={props.abdm.healthIdExists}
        />
      </section>
    </>
  );
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  abdm: state.abdm,
  patients: state.patients,
  app: state.app
});

export default connect(mapStateToProps)(ABDMCreate);

const CreateHealthId = (props) => {
  const navigate = useNavigate();

  const [error, setError] = useState(null);
  const [formData, setFormData] = useState({
    healthId: "",
    firstName: "",
    middleName: "",
    lastName: "",
    year: "",
    date: "",
    month: "",
    email: "",
    gender: "",
    stateCode: "",
    pinCode: "",
    address: "",
    districtCode: "",
    password: "",
    phoneNumber:
      typeof props.patients?.profiles?.[props.patients.currentProfile]
        ?.phoneNumber === "string"
        ? props.patients?.profiles?.[props.patients.currentProfile]?.phoneNumber
        : "",
    prevHealthId: null,
    patientId:
      typeof props.patients?.profiles?.[props.patients.currentProfile]
        ?.documentId === "string"
        ? props.patients?.profiles?.[props.patients.currentProfile]?.documentId
        : "",
    agreeTo: false
  });

  // check healthId exists
  useEffect(() => {
    healthIdExistCheckHandler();
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (
      typeof props.mobileNumber === "string" &&
      formData.phoneNumber !== props.mobileNumber
    ) {
      setFormData({
        ...formData,
        phoneNumber: props.mobileNumber
      });
    }
    // eslint-disable-next-line
  }, [props.mobileNumber]);

  useEffect(() => {
    const abha = props.patients.abhaNumberData;
    if (!abha) {
      return;
    }

    setFormData((prev) => ({
      ...prev,
      firstName: abha.firstName || "",
      middleName: abha.middleName || "",
      lastName: abha.lastName || "",
      year: abha.yearOfBirth || "",
      date: abha.dayOfBirth ? String(parseInt(abha.dayOfBirth, 10)) : "",
      month: getMonthName(abha.monthOfBirth) || "",
      email: abha.email || "",
      gender: getValidGender(abha.gender) || "",
      stateCode: abha.stateCode || "",
      pinCode: abha.pincode || "",
      address: abha.address || "",
      districtCode: abha.districtCode || "",
      phoneNumber: `+91${abha?.mobile}` || ""
    }));
  }, [props.patients.abhaNumberData]);

  // validate the formData
  useEffect(() => {
    let errorCount = 0;
    for (const [key, value] of Object.entries(formData)) {
      if (["email", "phoneNumber", "date", "month"].includes(key)) {
        continue;
      }
      if (
        !["prevHealthId"].includes(key) &&
        !["patientId"].includes(key) &&
        key === "healthId"
      ) {
        const isValidHealthId = Regex.healthId.test(value?.trim());
        const isAlreadyTaken = props.isHealthIdExists;

        if (!isValidHealthId || isAlreadyTaken) {
          errorCount++;
          continue;
        }
      }
    }
    if (errorCount <= 0) {
      setError(false);
    } else {
      setError(true);
    }
  }, [formData, props, props.isHealthIdExists]);

  const healthIdExistCheckHandler = () => {
    const rawHealthId = formData?.healthId;
    const healthId = rawHealthId?.trim() || "";

    const isInvalid =
      healthId.length < 4 ||
      healthId.length > 18 ||
      !Regex.healthId.test(healthId) ||
      props.loading ||
      formData?.prevHealthId === healthId;

    if (isInvalid) {
      return;
    }

    setFormData((prev) => {
      return {
        ...prev,
        prevHealthId: healthId
      };
    });

    checkHealthIdExists(healthId);
  };

  return (
    <Routes>
      <Route
        path="/*"
        element={
          <PersonalDetailsForm
            formData={formData}
            setFormData={setFormData}
            loading={props.loading}
            patients={props.patients}
            authMode={props.authMode}
            setStep={props.setStep}
          />
        }
      />
      <Route
        path="/abhaDetails"
        element={
          <ABHADetailsForm
            patients={props.patients}
            auth={props.auth}
            loading={props.loading}
            formData={formData}
            setFormData={setFormData}
            createHealthIdOnSubmit={(data) => {
              // if (props.abdm.healthIdExists) {
              createHealthId(
                healthIdSchema(data, props.patients?.transaction?.id),
                navigate
              );
              // } else {
              //   setErrorStatus("Health Id exists");
              // }
            }}
            isHealthIdExists={props.isHealthIdExists}
            error={error}
            healthIdExistCheckHandler={healthIdExistCheckHandler}
          />
        }
      />
      <Route
        path="/success/*"
        element={
          <SuccessScreen
            formData={formData}
            setFormData={setFormData}
            phoneNumber={props.auth.data.phoneNumber}
            auth={props.auth}
            patients={props.patients}
            loading={props.loading}
            isHealthIdExists={props.isHealthIdExists}
            backButtonOnClick={() => {
              navigate("/");
              setTransactionId(null);
            }}
          />
        }
      />
    </Routes>
  );
};

function PersonalDetailsForm(props) {
  const navigate = useNavigate();
  const disableContinueButton = () => {
    return props.formData.firstName &&
      props.formData.year &&
      props.formData.gender &&
      props.formData.stateCode &&
      props.formData?.pinCode?.length === 6 &&
      props.formData.address &&
      props.formData.districtCode &&
      (!props.formData.email ||
        validation("email", props.formData.email).status === true) &&
      validation("phoneNumber", props.formData.phoneNumber).status === true
      ? // &&
        // props.formData.agreeTo
        false
      : true;
  };

  const getAuthModeAndValue = () => {
    const { transaction, abhaNumberData } = props.patients;

    const value = transaction?.phoneNumber;
    if (value?.includes("+91")) {
      return { title: "PHONE NO", value };
    }
    if (value?.includes("@")) {
      return { title: "EMAIL", value };
    }
    return {
      title: "ABHA NO",
      value: deFormatABHANumber(abhaNumberData?.ABHANumber)
    };
  };

  return (
    <form
      className="padding-horizontal-larger inherit-parent-height display-flex flex-direction-column flex-justify-content-space-between"
      onChange={(event) => {
        /** clear healthIdExists status in redux store */
        if (event.target.name === "healthId") {
          clearHealthIdExistsStatus();
        }

        if (props.loading === true && event.target.name === "healthId") {
          return;
        }

        if (event.target.name === "agreeTo") {
          props.setFormData({
            ...props.formData,
            [event.target.name]: event.target.checked
          });
        } else {
          props.setFormData({
            ...props.formData,
            [event.target.name]: event.target.value
          });
        }
      }}
      onSubmit={(event) => {
        event.preventDefault();
        navigate("abhaDetails");
      }}
    >
      <div>
        <div className="text-align-center letter-spacing-large font-family-gilroy-regular font-size-small font-color-secondary padding-top-larger padding-bottom-large">
          <div>YOUR ARE CREATING ABHA ADDRESS FOR</div>
          <div>
            {getAuthModeAndValue()?.title} : {getAuthModeAndValue().value}
          </div>
        </div>

        {(props.patients.abhaNumberData?.profilePhoto ||
          props.patients.abhaNumberData?.photo) && (
          <div className="display-flex flex-justify-content-center padding-bottom-large">
            <RoundedProfilePicture
              src={`data:image/png;base64, ${
                props.patients.abhaNumberData?.profilePhoto ||
                props.patients.abhaNumberData?.photo
              }`}
              size="medium"
            />
          </div>
        )}
        <InputBox
          labelClassName="letter-spacing-4-percentage"
          className="inherit-parent-width border-radius-default"
          label="First Name *"
          type="text"
          required
          name="firstName"
          value={props.formData.firstName}
          disabled={props.patients.abhaNumberData?.firstName ? true : false}
        />
        <div className="display-flex">
          <InputBox
            labelClassName="letter-spacing-4-percentage"
            className="inherit-parent-width border-radius-default margin-right-default padding-top-medium"
            label="Middle Name"
            type="text"
            name="middleName"
            size="half"
            value={props.formData.middleName}
            disabled={props.patients.abhaNumberData?.middleName ? true : false}
          />
          <InputBox
            labelClassName="letter-spacing-4-percentage"
            className="inherit-parent-width border-radius-default margin-left-default padding-top-medium"
            label="Last Name"
            type="text"
            size="half"
            disabled={props.patients.abhaNumberData?.lastName ? true : false}
            name="lastName"
            value={props.formData.lastName}
          />
        </div>
        <div className="display-flex padding-top-large">
          <NativeSelect
            className="margin-right-large"
            labelClassName="letter-spacing-4-percentage"
            selectClassName="text-transform-capitalize padding-top-large"
            optionsClassName="text-transform-capitalize"
            name="year"
            label="YEAR *"
            required
            size="small"
            data-cy="year"
            disabled={props.patients.abhaNumberData?.yearOfBirth ? true : false}
            value={props.formData.year}
            options={["", ...returnYearArrayForSelectBox(1900)]}
          />
          <NativeSelect
            className="margin-right-large"
            labelClassName="letter-spacing-4-percentage"
            selectClassName="text-transform-capitalize padding-top-large"
            optionsClassName="text-transform-capitalize"
            name="month"
            label="MONTH"
            size="small"
            data-cy="month"
            disabled={
              props.formData?.yearOfBirth === "" ||
              props.patients.abhaNumberData?.monthOfBirth
                ? true
                : false
            }
            value={props.formData.month}
            options={["", ...months]}
          />
          <NativeSelect
            labelClassName="letter-spacing-4-percentage"
            selectClassName="text-transform-capitalize padding-top-large"
            optionsClassName="text-transform-capitalize"
            name="date"
            label="DATE"
            size="small"
            data-cy="date"
            disabled={
              props.formData?.month === "" ||
              props.patients.abhaNumberData?.dayOfBirth
                ? true
                : false
            }
            value={props.formData.date}
            options={[
              "",
              ...getDateForYearAndMonth(
                props.formData.year,
                props.formData.month
              )
            ]}
          />
        </div>
        <div className="display-flex flex-center-children-vertically padding-top-large">
          <NativeSelect
            labelClassName="letter-spacing-4-percentage"
            selectClassName="text-transform-capitalize padding-top-large padding-left-default"
            optionsClassName="text-transform-capitalize"
            name="gender"
            label="Gender *"
            required
            size="half"
            data-cy="gender"
            disabled={props.patients.abhaNumberData?.gender ? true : false}
            value={props.formData.gender}
            options={["", "male", "female", "others"]}
          />
        </div>
        {props.authMode !== "Phone" && (
          <InputBox
            labelClassName="letter-spacing-4-percentage"
            className="inherit-parent-width border-radius-default padding-top-medium"
            label="Phone Number"
            type="tel"
            name="phoneNumber"
            value={props.formData.phoneNumber}
            disabled={props.patients.abhaNumberData?.mobile ? true : false}
            validation={(value) => validation("phoneNumber", value)}
          />
        )}
        {props.authMode !== "Email" && (
          <InputBox
            labelClassName="letter-spacing-4-percentage"
            className="inherit-parent-width border-radius-default padding-top-medium"
            label="Email"
            type="email"
            name="email"
            value={props.formData.email}
            disabled={props.patients.abhaNumberData?.email ? true : false}
            validation={(value) => validation("email", value)}
          />
        )}
        <TextArea
          type="text"
          className="padding-top-default"
          value={props.formData.address}
          name="address"
          label="Address *"
          data-cy="address"
          required
          disabled={props.patients.abhaNumberData?.address ? true : false}
          category="textarea"
          validation={(value) => validation("address", value)}
        />

        <div className="display-flex flex-center-children-vertically padding-top-large">
          <NativeSelect
            className="margin-right-default"
            labelClassName="letter-spacing-4-percentage"
            selectClassName="text-transform-capitalize padding-top-large padding-right-default"
            optionsClassName="text-transform-capitalize"
            name="stateCode"
            label="State *"
            required
            size="half"
            data-cy="stateCode"
            disabled={props.patients.abhaNumberData?.stateCode ? true : false}
            value={props.formData.stateCode}
            options={stateOptionsWithCode}
          />
          <NativeSelect
            className="margin-left-default"
            labelClassName="letter-spacing-4-percentage"
            selectClassName="text-transform-capitalize padding-top-large padding-left-default"
            optionsClassName="text-transform-capitalize"
            name="districtCode"
            label="District *"
            required
            size="half"
            data-cy="districtCode"
            disabled={
              props.patients.abhaNumberData?.districtCode ? true : false
            }
            value={props.formData.districtCode}
            options={stateCodeWithDistricts[props.formData.stateCode]}
          />
        </div>
        <InputBox
          labelClassName="letter-spacing-4-percentage"
          className="inherit-parent-width border-radius-default padding-top-large"
          label="Pincode *"
          type="tel"
          required
          name="pinCode"
          disabled={props.patients.abhaNumberData?.pincode ? true : false}
          value={props.formData.pinCode}
          validation={(value) => validation("pinCode", value)}
        />
        {/* <div className="inherit-parent-width display-flex padding-top-large text-align-left font-size-small margin-top-small">
          <CheckBox
            name="agreeTo"
            checked={props.formData.agreeTo}
            label={
              <div className="font-size-small">
                I agree to voluntarily share my identity information with Byepo
                Technologies to create my ABHA Address{" "}
                {
                  <span
                    className="cursor-pointer padding-left-small font-family-RHD-regular font-color-primary"
                    onClick={() => {
                      navigate("terms");
                    }}
                  >
                    User Information Agreement
                  </span>
                }
              </div>
            }
          />
        </div> */}
      </div>
      <div className="padding-bottom-larger">
        <Button
          text="Continue"
          data-cy="CONTINUE-BUTTON"
          boxShadow={false}
          className={"margin-top-large "}
          type="submit"
          disabled={disableContinueButton()}
          loading={props.loading}
        />
      </div>
      <Routes>
        <Route
          path="terms"
          element={
            <TermsAndConditionModal
              onClose={() => {
                navigate("");
              }}
            />
          }
        />
      </Routes>
    </form>
  );
}

function ABHADetailsForm(props) {
  const [suggestedIds, setSuggestedIds] = useState(null);

  const fetchSuggestions = async () => {
    const { auth } = props;
    const accessToken = auth.data.accessToken;
    const transactionId = props.patients?.transaction?.id;

    const response = await suggestABHAAddress(accessToken, {
      dayOfBirth: props.formData?.date?.toString().padStart(2, "0"),
      monthOfBirth: (getMonthNumber(props.formData?.month) + 1)
        ?.toString()
        .padStart(2, "0"),
      yearOfBirth: props.formData?.year,
      firstName: props.formData?.firstName?.trim() || "",
      lastName: props.formData?.lastName?.trim() || "",
      transactionId
    });

    if (response.success) {
      setSuggestedIds(response.data.abhaAddressList);
    }
  };

  useEffect(() => {
    if (
      props.formData?.date &&
      props.formData?.month &&
      props.formData?.year &&
      props.formData?.firstName
    ) {
      fetchSuggestions();
    }
    // eslint-disable-next-line
  }, [
    props.formData?.date,
    props.formData?.month,
    props.formData?.year,
    props.formData?.firstName
  ]);

  const getAuthModeAndValue = () => {
    const { transaction, abhaNumberData } = props.patients;

    const value = transaction?.phoneNumber;
    if (value?.includes("+91")) {
      return { title: "PHONE NO", value };
    }
    if (value?.includes("@")) {
      return { title: "EMAIL", value };
    }
    return {
      title: "ABHA NO",
      value: deFormatABHANumber(abhaNumberData?.ABHANumber)
    };
  };

  return (
    <form
      className="padding-horizontal-larger inherit-parent-height display-flex flex-justify-content-space-between flex-direction-column"
      autoComplete="off"
      onChange={(event) => {
        /** clear healthIdExists status in redux store */
        if (event.target.name === "healthId") {
          clearHealthIdExistsStatus();
        }
        if (props.loading === true && event.target.name === "healthId") {
          return;
        }
        props.setFormData((prev) => ({
          ...prev,
          [event.target.name]: event.target.value
        }));
      }}
      onSubmit={(event) => {
        event.preventDefault();
        let preSubmitData = { ...props.formData };
        preSubmitData.healthId = `${props.formData.healthId}@sbx`;

        props.createHealthIdOnSubmit(preSubmitData);
      }}
    >
      <div>
        <div className="text-align-center letter-spacing-large font-family-gilroy-regular font-size-small font-color-secondary padding-top-larger padding-bottom-large">
          <div>YOUR ARE CREATING ABHA ADDRESS FOR</div>
          <div>
            {getAuthModeAndValue()?.title} : {getAuthModeAndValue()?.value}
          </div>
        </div>
        <InputBox
          inputSuffixPlaceHolder={"@sbx"}
          labelClassName="letter-spacing-4-percentage"
          className="inherit-parent-width border-radius-default padding-top-large"
          label="ABHA ADDRESS *"
          type="text"
          name="healthId"
          autoComplete="off"
          autoFocus={false}
          value={props.formData.healthId}
          loading={props.loading}
          inputNotesClassName="font-color-primary font-size-smaller padding-top-small"
          notes={
            props.formData.healthId &&
            props.isHealthIdExists === false && (
              <div style={{ color: "green", marginBottom: 6 }}>
                This ABHA Address is available.
              </div>
            )
          }
          validation={() => {
            if (
              props.formData.healthId.length < 8 ||
              props.formData.healthId.length > 18
            ) {
              return {
                status: false,
                message:
                  "ABHA Address must be between 8 and 18 characters long."
              };
            } else if (
              Regex.healthId?.test(props.formData.healthId) === false
            ) {
              return {
                status: false,
                message:
                  "ABHA Address must start with a letter and may contain only one dot or underscore in between."
              };
            } else if (props.isHealthIdExists === true) {
              return {
                status: false,
                message:
                  "This ABHA Address is already taken. Please choose another."
              };
            } else {
              return {
                status: true
              };
            }
          }}
          autocomplete="off"
          onOutOfFocus={props.healthIdExistCheckHandler}
          onBlur={props.healthIdExistCheckHandler}
        />

        {isValidArray(suggestedIds) && (
          <div>
            <div
              style={{
                color: "black",
                marginBottom: 4,
                marginTop: "4px",
                fontSize: "12px"
              }}
            >
              Suggestions:
            </div>

            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "8px"
              }}
            >
              {suggestedIds.map((id) => (
                <div
                  key={id}
                  style={{
                    color: "blue",
                    cursor: "pointer",
                    textDecoration: "underline",
                    whiteSpace: "nowrap",
                    width: "fit-content",
                    fontSize: "12px"
                  }}
                  onClick={() =>
                    props.setFormData((prev) => ({
                      ...prev,
                      healthId: id
                    }))
                  }
                >
                  {id}
                </div>
              ))}
            </div>
          </div>
        )}

        <InputBox
          className="inherit-parent-width border-radius-default margin-bottom-default"
          name="password"
          autoComplete="new-password"
          label="Password *"
          type="password"
          value={props.formData.password}
          validation={(value) => validation("password", value)}
          required
        />
        <InputBox
          className="inherit-parent-width border-radius-default margin-bottom-default"
          name="confirmPassword"
          autoComplete="new-password"
          label="Confirm Password *"
          type="password"
          validation={(value) => {
            if (value !== props.formData.password) {
              return {
                status: false,
                message: "Password does not match"
              };
            }
          }}
          value={props.formData.confirmPassword}
          required
        />
      </div>

      <div>
        <Button
          text="Submit"
          data-cy="CONTINUE-BUTTON"
          boxShadow={false}
          className="margin-top-large margin-bottom-larger"
          required
          type="submit"
          disabled={
            !props.error &&
            props.formData.password &&
            props.formData.password === props.formData.confirmPassword &&
            validation("password", props.formData.password).status === true &&
            validation("phoneNumber", props.formData.phoneNumber).status ===
              true
              ? false
              : true
          }
          loading={props.loading}
        />
      </div>
    </form>
  );
}

function SuccessScreen(props) {
  const navigate = useNavigate();
  return (
    <div className="padding-larger inherit-parent-height inherit-parent-width">
      <ProcessSuccess
        title="Congratulations! ABHA address is created successfully"
        description={
          <div>
            YOUR ABHA ADDRESS IS{" "}
            <span className="font-family-gilroy-bold">
              {props.patients?.recentlyCreatedABHAIdData?.healthId}
            </span>
          </div>
        }
        buttonName="Login"
        information={
          props.patients?.recentlyCreatedABHAIdData?.phoneNumber ===
          props.auth?.data?.phoneNumber
            ? false
            : "It seems that you have created ABHA address with a different phone number than your Ninto account. Click confirm to login with that account"
        }
        alternative={
          props.patients?.recentlyCreatedABHAIdData?.phoneNumber ===
          props.auth.data.phoneNumber ? (
            false
          ) : (
            <div className="font-weight-normal padding-top-large font-family-gilroy-medium font-size-small font-color-secondary inherit-parent-width text-align-center">
              Stay logged in with your previous account?
              <span
                onClick={props.backButtonOnClick}
                className="padding-left-small font-color-primary"
              >
                Back
              </span>
            </div>
          )
        }
        confirmClick={() => {
          const createdData = props.patients?.recentlyCreatedABHAIdData;
          if (createdData?.phoneNumber === props.auth.data.phoneNumber) {
            navigate("/");
            setTransactionId(null);
          } else {
            switchLoginWithCustomToken(createdData, navigate);
          }
        }}
      />

      <Routes>
        <Route
          path="linkedProfiles"
          element={
            <LinkedProfileModal
              patients={props.patients}
              onClose={() => navigate("")}
            />
          }
        />
      </Routes>
    </div>
  );
}

const LinkedProfileModal = (props) => {
  const [selectedIndex, setSelectedIndex] = useState(null);
  const navigate = useNavigate();

  return (
    <Modal
      show={true}
      onClose={props.onClose}
      canIgnore={false}
      position="position-fixed bottom-0 left-0 right-0"
      boxShadow="none"
      borderRadius="none"
      width="inherit-parent-width"
      background="background-transparent"
      height="height-fit-to-content"
    >
      <div
        data-cy="multiple-login-modal"
        className="background-white padding-large font-family-gilroy-medium user-select-none"
      >
        <div className="inherit-parent-width inherit-parent-height">
          {typeof selectedIndex !== "number" && (
            <>
              <div className="text-align-center font-size-small padding-medium font-color-secondary">
                SELECT TO VIEW CONNECTED HEALTH ID
              </div>
              {props.patients.linkedProfiles?.map((data, index) => (
                <div
                  key={index}
                  onClick={() => setSelectedIndex(index)}
                  className="display-flex flex-justify-content-space-between padding-bottom-default"
                >
                  <div>{data.phoneNumber}</div>
                  <ArrowIcon />
                </div>
              ))}

              <div className="flex-center-children-vertically margin-vertical-large ">
                <hr
                  style={{ width: "100%" }}
                  className="border-color-secondary-lite border-top-left-right-none"
                />
                <span className="margin-horizontal-default font-color-tertiary font-size-small">
                  OR
                </span>
                <hr
                  style={{ width: "100%" }}
                  className="border-color-secondary-lite border-top-left-right-none"
                />
              </div>

              <div className="font-size-small text-align-center">
                Create health ID with same number?
                <span className="font-color-primary padding-left-small cursor-pointer">
                  Click here
                </span>
              </div>
            </>
          )}

          {typeof selectedIndex === "number" && (
            <>
              <div className="text-align-center font-size-small padding-medium font-color-secondary">
                CONNECTED HEALTH ID
              </div>
              <div className="text-align-center font-size-small font-color-secondary">
                You will now logout from registered phone number then login to
                this number to access the shown health id(s)
              </div>

              <div className="padding-top-large">
                {props.patients.linkedProfiles?.[selectedIndex]?.phoneNumber}
              </div>

              <div
                className="flex-direction-row gap-0-point-5em margin-top-small flex-wrap overflow-auto padding-top-large padding-bottom-default padding-right-medium"
                style={{ height: "100px" }}
              >
                {props.patients.linkedProfiles?.[
                  selectedIndex
                ]?.linkedAbhaAddress.map((chip, idx) => (
                  <div
                    key={idx}
                    className="font-size-small text-overflow-ellipsis padding-small border-2px-lite-grey border-radius-default font-family-gilroy-regular font-color-secondary"
                  >
                    <span>{chip}</span>
                  </div>
                ))}
              </div>

              <section className="display-flex padding-top-larger">
                <Button
                  boxShadow={false}
                  type="button"
                  text="Continue"
                  className="border-1px-e5e5e5 margin-right-small"
                  onClick={() => {
                    switchLoginWithCustomToken(
                      {
                        customToken:
                          props.patients.linkedProfiles?.[selectedIndex]
                            ?.customToken
                      },
                      navigate
                    );
                  }}
                  data-cy="confirm-login-button"
                />
                <Button
                  boxShadow={false}
                  text="Back"
                  variant="secondary"
                  onClick={() => setSelectedIndex(null)}
                  className="font-color-secondary border-1px-e5e5e5 margin-left-small"
                  data-cy="cancel-login-button"
                />
              </section>
            </>
          )}
        </div>
      </div>
    </Modal>
  );
};
